import { useState } from "react";
import { Alert, Button, Paper, Tab, Tabs } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { PageTitle } from "../../../../shared/ui/common";
import CustomeLayout from "../../../../shared/ui/customeTable";
import Filters from "../../../../shared/ui/filters";
import usePromotions from "../../hooks/use-promotions";
import { promotionFilterSchema } from "../../lib/promotion-form";
import PromotionEditor from "./PromotionEditor";
import ReservationPanel from "./ReservationPanel";
import { promotionAmount } from "../../lib/promotion-amount";

const ignored = () => {};
export default function Promotions() {
  const [kind, setKind] = useState("plans");
  return <>
    <PageTitle title="تبلیغات" broadCrumb={[{ title: "تبلیغات", path: "/promotions" }]} />
    <Paper variant="outlined" className="md:mx-3 mx-1 mb-3">
      <Tabs value={kind} onChange={(_, next) => setKind(next)} aria-label="مدیریت تبلیغات">
        <Tab value="plans" label="پلن‌های تبلیغاتی" /><Tab value="placements" label="جایگاه‌های تبلیغاتی" />
        <Tab value="reservations" label="سفارش‌های تبلیغاتی" />
      </Tabs>
    </Paper>
    {kind === "reservations" ? <ReservationPanel /> : <Catalogue key={kind} kind={kind} />}
  </>;
}

function Catalogue({ kind }) {
  const catalogue = usePromotions(kind);
  const [editor, setEditor] = useState(null), [search, setSearch] = useState("");
  const plans = kind === "plans";
  const title = plans ? "پلن‌های تبلیغاتی" : "جایگاه‌های تبلیغاتی";
  const rows = catalogue.rows.map((row) => ({ ...row, id: plans ? row.id : row.code,
    ...(plans ? { priceDisplay: [row.priceMinor == null ? "یورو: تعریف نشده" : promotionAmount(row.priceMinor),
      row.rialPrice == null ? "ریال: تعریف نشده" : promotionAmount(row.rialPrice, "IRR")].join(" / "),
      durationDays: row.durationDays ?? "تعریف نشده",
      placementTitles: row.placements.map((item) => item.title).join("، ") } : {}) }));
  const schema = promotionFilterSchema(catalogue.headers);
  return <div className="md:mx-3 mx-1">
    <Paper variant="outlined" className="p-4 mb-3 flex flex-wrap justify-between gap-3">
      {schema.length > 0 && <Filters schema={schema} value={catalogue.query} loading={catalogue.loading && catalogue.headers.length === 0} onApply={catalogue.apply} />}
      {plans && <div className="flex flex-wrap gap-2">
        <Button variant="contained" disabled={catalogue.loading || Boolean(catalogue.error)}
          onClick={() => setEditor({ original: null })}>افزودن {plans ? "پلن جدید" : "جایگاه جدید"}</Button>
      </div>}
    </Paper>
    {catalogue.error && <Alert severity="error" className="mb-3" action={<Button onClick={catalogue.reload}>تلاش مجدد</Button>}>{catalogue.error}</Alert>}
    {catalogue.actionError && <Alert severity="error" className="mb-3">{catalogue.actionError}</Alert>}
    <CustomeLayout title={title} headers={catalogue.headers} rows={rows} loading={catalogue.loading && catalogue.headers.length === 0}
      refreshing={catalogue.loading && catalogue.headers.length > 0} length={catalogue.error ? null : catalogue.total}
      limit={catalogue.query.limit} setLimit={(limit) => catalogue.apply({ ...catalogue.query, limit: Number(limit) })}
      paginationMode={2} page={catalogue.query.page} setPage={catalogue.page} total_pages={Math.max(1, Math.ceil(catalogue.total / catalogue.query.limit))}
      search={search} setSearch={setSearch} setApplySearch={(next) => catalogue.apply({ ...catalogue.query, search: next })}
      setRefresh={catalogue.reload} selected={[]} setSelected={ignored} canSelect={false} currentRow={ignored}
      setting={{ TableType: "table" }} setAllRows={ignored} setSort={ignored}
      actions={[{ title: "عملیات", handler: (row) => row.isDeleted
        ? <Button disabled={catalogue.saving} onClick={() => { catalogue.restore(row).catch(ignored); }}>بازیابی</Button>
        : <Button startIcon={<Edit />} onClick={() => setEditor({ original: catalogue.rows.find((item) => (plans ? item.id : item.code) === row.id) })}>ویرایش</Button> }]} />
    {!catalogue.loading && !catalogue.error && rows.length === 0 && <p role="status" className="text-center p-4">{plans ? "پلنی مطابق فیلترها پیدا نشد." : "جایگاهی مطابق فیلترها پیدا نشد."}</p>}
    <PromotionEditor kind={kind} open={Boolean(editor)} original={editor?.original}
      close={() => setEditor(null)} catalogue={catalogue} />
  </div>;
}
